import React from "react";
import "./BasicReports.scss";
import Scorecard from "./Scorecard/Scorecard";
import SubjectWise from "./SubjectWise/SubjectWise";
import GoToAdvAnalytics from "./GoToAdvAnalytics/GoToAdvAnalytics";
import GoToAdvAnalytics1 from "./GoToAdvAnalytics1/GoToAdvAnalytics1";
import Buttons from "./Buttons/Buttons";
import PerformanceInsights from "../sharedAnalytics/performanceInsights";

const BasicReports = ({ basicAnalytics }) => {
  return (
    <div className="basic-reports">
      <Scorecard basicAnalytics={basicAnalytics} />
      <GoToAdvAnalytics />

      <SubjectWise subjectWiseAnalysis={basicAnalytics?.subject_wise_analysis} />

      {/* <PerformanceInsights analytics={basicAnalytics} /> */}

      <GoToAdvAnalytics1 />
      <Buttons />
    </div>
  );
};


export default BasicReports;
